// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"index__FullWidth___LbSro","Article":"index__Article___29dcR","image":"index__image___24dpN"};